import allData from 'airline-iata-code';
import YYLogo from '../assets/images/orgaLogo.png';
import EurowingsDiscoverLogo from '../assets/images/eurowingsDiscoverLogo.png';

const airlineLogo = (code) => {
  if (!code) return null;

  if (code === 'Z0') {
    code = 'N0';
  }
  if (code === 'YY') {
    return YYLogo;
  }
  if (code === '4Y') {
    return EurowingsDiscoverLogo;
  }

  const airlineData = allData(code);

  if (airlineData.length > 0) {
    return airlineData[0].logo;
  }
  return null;
};

export default airlineLogo;